module.exports = __webpack_public_path__ + "static/media/settings-icon.53fc0f51.svg";